module.exports = __webpack_public_path__ + "img/com.codeway.wonder.2357de88.png";